import { ICPOInternalTransfersFilter, ICPOInternalTransfersList, ITransferData } from 'models/cpo-internal-transfers';
import StandardResponse from 'models/standard-response';
import BaseService from 'services/base-service';

export default class CPOInternalTransfersServices {
    getCPOInternalTransfersList = async (
        data: ICPOInternalTransfersFilter,
    ): Promise<StandardResponse<ICPOInternalTransfersList>> => {
        try {
            const res = await BaseService({
                baseURL: process.env.REACT_APP_EMSP_ADMIN_API_URL,
                url: `/v1/admin/cpos/internal-transfers/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<ICPOInternalTransfersList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getTransferDetail = async (data: any, id: number): Promise<StandardResponse<ITransferData>> => {
        try {
            const res = await BaseService({
                baseURL: process.env.REACT_APP_EMSP_ADMIN_API_URL,
                url: `v1/admin/cpos/internal-transfer/${id}`,
                method: 'post',
                data,
            });
            return new StandardResponse<ITransferData>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getTransferDetailsListCsvLink = async (id: number, data: any): Promise<StandardResponse<string>> => {
        try {
            const res = await BaseService({
                baseURL: process.env.REACT_APP_EMSP_ADMIN_API_URL,
                url: `/v1/admin/cpos/internal-transfer/${id}/export`,
                method: 'post',
                data,
            });
            return new StandardResponse<string>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
}
